export const addresses = {
  assetStoreProvider: "0xFe278A24bB517A2d2A113FA350173a6C134EECab",
  coinProvider: "0x0c76f60Fef1E0189161C59cE15682ABF3d38cbAe",
  colorSchemes: "0x8f1b45f7c56bA3db00f27Ce113fa8d8335677336",
  bitcoinArtProvider: "0xdfbf32A5d04aa5CD148415477591109B63b2bfB5",
  bitcoinToken: "0x5743cF32FfD4C1F2093AE2C94E1d036B6472E7B9",
};
